import { Button, Dropdown, Space, Spin, Tag, Typography } from 'antd'
import {
  ClockCircleOutlined,
  DownOutlined,
  PauseOutlined,
  PlayCircleOutlined,
  SettingOutlined,
} from '@ant-design/icons'
import {
  getAutomationStatus,
  getAutomationStatusLabel,
} from '../../models/Automation'
import LocalizationKeys from '../../i18n/LocalizationKeys'
import i18n from '../../i18n/setupLocalization'
import {
  getAutomationWithId,
  selectAutomationById,
  setSelectedAutomation,
  updateAutomation,
} from '../../store/AutomationReducer'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import { Flex, MenuProps } from 'antd/lib'
import { Actions } from '../../modules/sbrm/components/Actions'
import { SBRMType } from '../../modules/sbrm/SBRMModel'
import { capitalize } from '../../helpers/String'

const { Text } = Typography

export const StatusUpdator = () => {
  const { automationId } = useParams<{ automationId: string }>()
  const automation = useAppSelector(selectAutomationById(automationId ?? ''))

  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!automationId) {
      return
    }
    dispatch(getAutomationWithId(automationId)).then(() => {
      dispatch(setSelectedAutomation(automationId))
    })
  }, [automationId])

  if (!automation) {
    return <Spin />
  }

  const items: MenuProps['items'] = [
    {
      label: (
        <Actions
          actions={['update']}
          entity={SBRMType.automation}
          entityId={automation.id}
          trigger={'Schedule'} //TODO A traduire
        />
      ),
      key: '1',
      icon: <ClockCircleOutlined />,
    },
  ]
  const menuProps = {
    items,
    onClick: () => {},
  }

  const updateAutomationStatus = (isActive: boolean) => {
    dispatch(updateAutomation({ ...automation, isActive: isActive }))
  }

  return (
    <Flex>
      {(() => {
        switch (getAutomationStatus(automation)) {
          case 'live':
            return (
              <Flex align="center" gap={12}>
                <Space>
                  <div className="dot-white"></div>
                  <Text style={{ fontWeight: 600, color: 'white' }}>
                    {i18n.t(LocalizationKeys.Page.AutomationPage.Status, {
                      status: getAutomationStatusLabel(automation),
                    })}
                  </Text>
                </Space>
                <Button
                  size="large"
                  icon={<PauseOutlined />}
                  onClick={() => {
                    updateAutomationStatus(false)
                  }}
                />
              </Flex>
            )
          case 'scheduled':
            return (
              <Actions
                actions={['update']}
                entity={SBRMType.automation}
                entityId={automation.id}
                trigger={
                  <Space.Compact>
                    <Button size="large">
                      {capitalize(
                        i18n.t(
                          LocalizationKeys.Page.AutomationPage.StatusScheduled
                        )
                      )}
                    </Button>
                    <Button icon={<SettingOutlined />} size="large"></Button>
                  </Space.Compact>
                }
              />
            )
          case 'paused':
            return (
              <Dropdown.Button
                className="w-full gleap-automation-make-live"
                size="large"
                icon={<DownOutlined />}
                onClick={() => {
                  updateAutomationStatus(true)
                }}
                menu={menuProps}
              >
                <Space>
                  <PlayCircleOutlined />
                  Make live
                </Space>
              </Dropdown.Button>
            )
          default:
            return 'Unknown status'
        }
      })()}
    </Flex>
  )
}

export type StatusUpdatorType = { StatusUpdator: typeof StatusUpdator }
